import React, { forwardRef, useImperativeHandle } from 'react';
import styled from '@emotion/styled'
import { Accept, useDropzone } from 'react-dropzone';

interface FileDropBoxProps {
  text: string;
  accept: Accept;
  onDrop: (files: File[]) => void;
}

export interface FileDropBoxHandle {
  importFile: () => void;
}

interface StyledFileDropBoxProps {
  isFocused: boolean;
  isDragAccept: boolean;
  isDragReject: boolean;
}

const getColor = (props: StyledFileDropBoxProps) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isFocused) {
    return '#2196f3';
  }
  return '#eeeeee';
}

const StyledFileDropBox = styled.section<StyledFileDropBoxProps>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: #bdbdbd;
  flex-direction: column;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  outline: none;
  transition: border .24s ease-in-out;
`;

export const FileDropBox = forwardRef<FileDropBoxHandle, FileDropBoxProps>(({ text, accept, onDrop }, ref) => {
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    open
  } = useDropzone({
    accept: accept,
    multiple: false,
    onDrop: onDrop
  });

  useImperativeHandle(ref, () => ({
    importFile: () => open()
  }));

  return <StyledFileDropBox {...getRootProps({isFocused, isDragAccept, isDragReject})}>
    <input {...getInputProps()} />
    <p>{text}</p>
  </StyledFileDropBox>
});
